module.exports = __webpack_public_path__ + "img/yi.74f3c0a6.png";